__webpack_require__.p = "/Pokemon_binder/";